import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
} from 'react-router-dom';

import App from './app';
import { DeviceProvider } from 'hooks/useDevice';
import reportWebVitals from './reportWebVitals';

import './i18n';

import './index.css';

if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DEMO === 'true') {
  require('./demo/installShims').installDemoShims();
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DeviceProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </DeviceProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
